import React, { useState } from 'react';
import { Send } from 'lucide-react';

const ContactForm = ({ 
  title = 'Get in Touch',
  description = 'Have questions? We\'d love to hear from you.',
  submitButtonText = 'Send Message',
  showCompanyField = true,
  showPhoneField = true,
  className = '' 
}) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', formData);
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className={`bg-card border border-border rounded-lg p-8 text-center ${className}`}>
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <Send className="w-8 h-8 text-green-600" />
        </div>
        <h3 className="text-xl font-semibold mb-2">Message Sent!</h3>
        <p className="text-muted-foreground">We'll get back to you as soon as possible.</p>
      </div>
    );
  }

  return (
    <div className={`bg-card border border-border rounded-lg p-8 ${className}`}>
      {title && <h3 className="text-2xl font-semibold mb-2">{title}</h3>}
      {description && <p className="text-muted-foreground mb-6">{description}</p>}
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Name *</label>
            <input
              type="text"
              required
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              className="w-full px-4 py-2 border border-border rounded-md focus:ring-2 focus:ring-primary focus:border-transparent"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Email *</label>
            <input
              type="email"
              required
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              className="w-full px-4 py-2 border border-border rounded-md focus:ring-2 focus:ring-primary focus:border-transparent"
            />
          </div>
        </div>
        
        {(showCompanyField || showPhoneField) && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {showCompanyField && (
              <div>
                <label className="block text-sm font-medium mb-1">Company</label>
                <input
                  type="text"
                  value={formData.company}
                  onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                  className="w-full px-4 py-2 border border-border rounded-md focus:ring-2 focus:ring-primary focus:border-transparent"
                />
              </div>
            )}
            {showPhoneField && (
              <div>
                <label className="block text-sm font-medium mb-1">Phone</label>
                <input
                  type="tel"
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  className="w-full px-4 py-2 border border-border rounded-md focus:ring-2 focus:ring-primary focus:border-transparent"
                />
              </div>
            )}
          </div>
        )}
        
        <div>
          <label className="block text-sm font-medium mb-1">Message *</label>
          <textarea
            required
            rows={4}
            value={formData.message}
            onChange={(e) => setFormData({ ...formData, message: e.target.value })}
            className="w-full px-4 py-2 border border-border rounded-md focus:ring-2 focus:ring-primary focus:border-transparent resize-none"
          />
        </div>
        
        <button
          type="submit"
          className="w-full bg-primary text-white py-3 rounded-md font-medium hover:bg-primary-hover transition-colors flex items-center justify-center gap-2"
        >
          {submitButtonText}
          <Send size={18} />
        </button>
      </form>
    </div>
  );
};

ContactForm.builderConfig = {
  props: {
    title: {
      type: 'text',
      label: 'Title',
      default: 'Get in Touch',
    },
    description: {
      type: 'text',
      label: 'Description',
      default: 'Have questions? We\'d love to hear from you.',
    },
    submitButtonText: {
      type: 'text',
      label: 'Submit Button Text',
      default: 'Send Message',
    },
    showCompanyField: {
      type: 'boolean',
      label: 'Show Company Field',
      default: true,
    },
    showPhoneField: {
      type: 'boolean',
      label: 'Show Phone Field',
      default: true,
    },
  },
};

export default ContactForm;
